import React, { Component } from 'react'
import Layout from '../../components/Layout'
import UserToolbar from '../../components/UserToolbar'
import VetorizacaoNav from '../../components/VetorizacaoNav'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Chip from '@material-ui/core/Chip'
import SearchIcon from '@material-ui/icons/Search'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import { bookVectorization } from '../../api'

const styles = () => ({
  root: {
    padding: '16px 0',
  },
  form: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    flexWrap: 'wrap',
    padding: '16px',
    marginBottom: '16px',
  },
  isbnControl: {
    minWidth: 220,
  },
  queryControl: {
    minWidth: 320,
    flex: 1,
  },
  topKControl: {
    minWidth: 110,
  },
  scoreControl: {
    minWidth: 120,
  },
  actions: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  errorBox: {
    padding: '16px',
    backgroundColor: '#fff3f3',
    borderRadius: '4px',
    marginBottom: '16px',
  },
  emptyRow: {
    textAlign: 'center',
    padding: '24px',
    color: 'rgba(0,0,0,0.54)',
  },
  resultMeta: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    marginTop: '6px',
  },
})

class BookVectorSearch extends Component {
  state = {
    isbn: '',
    query: '',
    topK: 15,
    scoreMinimo: 0.5,
    touched: false,
    loading: false,
    error: null,
    responseQuery: '',
    results: [],
    searched: false,
  }

  getErrorMessage = (err) => {
    const data = ((err || {}).response || {}).data

    if (!data) return 'Erro ao buscar livro vetorizado.'
    if (typeof data === 'string') return data
    if (typeof data.message === 'string') return data.message
    if (typeof data.detail === 'string') return data.detail
    if (data.detail && typeof data.detail.message === 'string') return data.detail.message

    return 'Erro ao buscar livro vetorizado.'
  }

  isValid = () => {
    return this.state.isbn.trim().length > 0 && this.state.query.trim().length > 0
  }

  handleSubmit = (event) => {
    event.preventDefault()

    if (!this.isValid()) {
      this.setState({ touched: true })
      return
    }

    const { isbn, query, topK, scoreMinimo } = this.state

    this.setState({
      loading: true,
      error: null,
      searched: true,
      results: [],
      responseQuery: '',
    })

    bookVectorization
      .searchBookVectorsByIsbn({
        isbn: isbn.trim(),
        query: query.trim(),
        topK,
        scoreMinimo,
      })
      .then((response) => {
        const data = response.data || {}
        this.setState({
          loading: false,
          responseQuery: data.query || query.trim(),
          results: data.resultados || [],
          error: null,
        })
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: this.getErrorMessage(err),
          results: [],
        })
      })
  }

  renderScore = (score) => {
    if (typeof score !== 'number') return '--'
    return score.toFixed(2)
  }

  renderResults = () => {
    const { classes } = this.props
    const { loading, results, searched, error } = this.state

    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '32px' }}>
          <CircularProgress />
        </div>
      )
    }

    if (!searched && !error) {
      return (
        <Typography className={classes.emptyRow}>
          Informe o ISBN e uma busca para consultar os vetores do livro.
        </Typography>
      )
    }

    if (!results.length) {
      return (
        <Typography className={classes.emptyRow}>
          Nenhum trecho vetorizado encontrado para essa busca.
        </Typography>
      )
    }

    return (
      <Table fixedHeader={false}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn>Livro / Capítulo</TableHeaderColumn>
            <TableHeaderColumn>Trecho</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '90px' }}>Score</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {results.map((item, index) => (
            <TableRow key={item.idVetor || index}>
              <TableRowColumn>
                <div>
                  <Typography variant="body2" title={item.titulo}>
                    {item.titulo || '--'}
                  </Typography>
                  <Typography variant="caption" color="textSecondary" title={item.capitulo}>
                    {item.capitulo || 'Capítulo não informado'}
                  </Typography>
                  <div className={classes.resultMeta}>
                    {item.isbn ? <Chip label={item.isbn} size="small" /> : null}
                    {item.especialidade ? (
                      <Chip label={item.especialidade} size="small" color="primary" />
                    ) : null}
                    {item.ano ? <Chip label={String(item.ano)} size="small" /> : null}
                  </div>
                </div>
              </TableRowColumn>
              <TableRowColumn>
                <Typography variant="body2">{item.trecho || '--'}</Typography>
                {item.idVetor ? (
                  <Typography variant="caption" color="textSecondary">
                    ID Vetor: {item.idVetor}
                  </Typography>
                ) : null}
              </TableRowColumn>
              <TableRowColumn style={{ width: '90px' }}>{this.renderScore(item.score)}</TableRowColumn>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  render() {
    const { classes } = this.props
    const { isbn, query, topK, scoreMinimo, touched, loading, error, results, responseQuery, searched } =
      this.state
    const isbnError = touched && !isbn.trim()
    const queryError = touched && !query.trim()

    return (
      <Layout toolBarRight={UserToolbar}>
        <div className={classes.root}>
          <VetorizacaoNav active="busca" />

          <Typography variant="h6" style={{ marginBottom: 16 }}>
            Buscar Livro Vetorizado
          </Typography>

          <Paper elevation={2}>
            <form className={classes.form} onSubmit={this.handleSubmit} noValidate>
              <FormControl className={classes.isbnControl} error={isbnError}>
                <InputLabel htmlFor="book-vector-search-isbn">ISBN *</InputLabel>
                <Input
                  id="book-vector-search-isbn"
                  value={isbn}
                  disabled={loading}
                  onChange={(event) => this.setState({ isbn: event.target.value })}
                />
                <FormHelperText>
                  {isbnError ? 'ISBN é obrigatório.' : 'Restrição da busca ao livro.'}
                </FormHelperText>
              </FormControl>

              <FormControl className={classes.queryControl} error={queryError}>
                <InputLabel htmlFor="book-vector-search-query">Busca *</InputLabel>
                <Input
                  id="book-vector-search-query"
                  value={query}
                  disabled={loading}
                  onChange={(event) => this.setState({ query: event.target.value })}
                />
                <FormHelperText>
                  {queryError ? 'Busca é obrigatória.' : 'Pergunta ou termo para busca semântica.'}
                </FormHelperText>
              </FormControl>

              <FormControl className={classes.topKControl}>
                <InputLabel htmlFor="book-vector-search-top-k">Resultados</InputLabel>
                <Select
                  value={topK}
                  disabled={loading}
                  onChange={(event) => this.setState({ topK: event.target.value })}
                  inputProps={{ id: 'book-vector-search-top-k' }}
                >
                  {[5, 15, 20, 50, 99].map((value) => (
                    <MenuItem key={value} value={value}>
                      {value === 99 ? 'Sem limite' : value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl className={classes.scoreControl}>
                <InputLabel htmlFor="book-vector-search-score">Score mínimo</InputLabel>
                <Input
                  id="book-vector-search-score"
                  type="number"
                  value={scoreMinimo}
                  disabled={loading}
                  onChange={(event) =>
                    this.setState({
                      scoreMinimo: event.target.value ? parseFloat(event.target.value) : undefined,
                    })
                  }
                  inputProps={{ min: 0, max: 1, step: 0.05 }}
                />
              </FormControl>

              <div className={classes.actions}>
                <Button type="submit" variant="contained" color="primary" disabled={loading}>
                  <SearchIcon style={{ marginRight: 6, fontSize: 18 }} />
                  {loading ? 'Buscando...' : 'Buscar'}
                </Button>
              </div>
            </form>
          </Paper>

          {error ? (
            <div className={classes.errorBox}>
              <Typography color="error">{error}</Typography>
            </div>
          ) : null}

          {searched && !loading && !error ? (
            <Typography variant="caption" color="textSecondary" style={{ margin: '12px 0', display: 'block' }}>
              {results.length} {results.length === 1 ? 'resultado encontrado' : 'resultados encontrados'}
              {responseQuery ? ' para "' + responseQuery + '"' : ''}
            </Typography>
          ) : null}

          <Paper elevation={4}>{this.renderResults()}</Paper>
        </div>
      </Layout>
    )
  }
}

export default withStyles(styles)(BookVectorSearch)



// WEBPACK FOOTER //
// ./src/containers/BookVectorSearch/index.js